/**
 * Checkout-cancelled landing (ADR-0022 §4 / cancel_url).
 *
 * RC Web Billing redirects here if the user abandons checkout. Calm, additive,
 * no nag (brand guide §2 ED-safe lexicon): we simply offer the way back.
 */
import { Link } from 'react-router';

export default function BillingCancelPage() {
  return (
    <div className="mx-auto flex max-w-md flex-col items-center gap-4 py-16 text-center">
      <h2 className="text-xl font-medium tracking-tight text-ink dark:text-ink">Checkout closed</h2>
      <p className="text-sm text-ink-soft dark:text-ink-soft">
        No charge was made. You can upgrade any time from Settings whenever it suits you.
      </p>
      <div className="flex gap-3">
        <Link
          to="/settings#plan"
          className="rounded-xl bg-leaf/100 px-4 py-2 text-sm font-semibold text-white
                     hover:bg-leaf-deep focus:outline-none focus:ring-2 focus:ring-leaf"
        >
          Back to plans
        </Link>
        <Link
          to="/"
          className="rounded-xl border border-husk px-4 py-2 text-sm font-semibold text-ink
                     hover:bg-husk/20 focus:outline-none focus:ring-2 focus:ring-leaf dark:border-ink/20 dark:text-ink"
        >
          Go home
        </Link>
      </div>
    </div>
  );
}
